export default "__VITE_ASSET__D6hl6Q0j__"